import React from 'react';

import { Box, Flex } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

import { LoadingShimmerProps, ShimmerProps } from './LoadingShimmer.common';

const animationStyles = {
  '@keyframes fadeIn': {
    '0%': { opacity: 0.3 },
    '50%': { opacity: 1 },
    '100%': { opacity: 0.3 },
  },
  animation: 'fadeIn 1s linear infinite',
  transformOrigin: '50% 100%',
};

const Shimmer = ({
  circle,
  color,
  height,
  width,
  borderRadius,
  flexWidth,
}: ShimmerProps): JSX.Element => {
  const { colors, space } = useTheme();
  const borderRadiusValue = borderRadius || (circle ? 'round' : space['1x']);
  return (
    <Box
      sx={{
        backgroundColor: color?.toString() || colors.neutral['200'].toString(),
        overflow: 'hidden',
        flex: flexWidth,
      }}
      borderRadius={borderRadiusValue}
      height={height}
      width={width}
    />
  );
};

const LoadingShimmer = ({
  circle,
  color,
  height = 30,
  width = 'auto',
  borderRadius,
  mt = '4x',
  ml = '4x',
  mr = '4x',
  shimmerFlex = 1,
  paddingFlex = 0,
  ...props
}: LoadingShimmerProps): JSX.Element => {
  const boxProps = {
    mt,
    ml,
    mr,
    height,
    width,
    flexDirection: 'row',
    alignSelf: 'stretch',
    ...props,
  };

  return (
    <Flex sx={animationStyles} {...boxProps}>
      <Shimmer
        circle={circle}
        color={color}
        height={height}
        width={width}
        borderRadius={borderRadius}
        flexWidth={shimmerFlex}
      />
      <Flex flex={`${paddingFlex}`} />
    </Flex>
  );
};

export default LoadingShimmer;
